import React, { useMemo } from 'react';
import { Stack, Grid, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { ChevronRightRounded } from '@mui/icons-material';
import ItemDetail from './ItemDetail';
import LogOnEnter from '../../CustomComponents/LogOnEnter';
import VendorDetails from './VendorDetails';

function ItemEntry(props) {
    const theme = useTheme();
    const itemHasAcceptedSwap = useMemo(() => {
        if (props.draft.recommendations[props.item.category]) {
            const swapRec = props.draft.recommendations[props.item.category].find((rec) => rec.type === 'swap' && rec.item.id === props.item.id);
            if (swapRec?.status === 'accepted') {
                return true;
            }
        }
        return false;
    }, [props]);

    const itemToDisplay = useMemo(() => {
        if (itemHasAcceptedSwap) {
            const swapRec = props.draft.recommendations[props.item.category].find((rec) => rec.type === 'swap' && rec.item.id === props.item.id);
            return swapRec.recommended_item;
        }
        return props.item;
    }, [props]);


    function handleEdit() {
        props.openItemView(itemToDisplay);
    }

    const yearlyCost = useMemo(() => {
        return (itemToDisplay.cost * props.item.hold_quantity + itemToDisplay.cost * props.item.open_quantity) * props.draft.card.yearly_stats?.usage_count / 100;
    }, [props]);

    return (
        <Grid container p={1.5} sx={{ 
            backgroundColor: '#FFFFFF', 
            borderRadius: '4px',
            border: props.isSelected ? `1.5px solid ${theme.palette.primary.main}` : '1px solid transparent',
            boxShadow: props.isSelected ? theme.shadows[4] : theme.shadows[1],
            cursor: 'pointer',
            '&:hover': {
                boxShadow: theme.shadows[4],
                border: `1.5px solid ${theme.palette.primary.main}`,
            }
        }} onClick={handleEdit}>
            <Grid item xs={10} sx={{ display: 'flex', flexDirection: 'column', alignContent: 'center' }}>
                <LogOnEnter action='viewed_item' data={{ item: itemToDisplay }}>
                    <Stack spacing={0.5} pr={2}>
                        <Box sx={{ fontSize: '12px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '100%' }}>
                            <Typography variant='normal'>
                                {itemToDisplay.name}
                            </Typography>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <VendorDetails item={itemToDisplay} recommendation={{ status: 'open' }} />
                        </Box>
                        <Stack direction='row' spacing={1}>
                            {  props.draft.card.yearly_stats && 
                                <ItemDetail type='cost' data={yearlyCost} />
                            }
                        </Stack>
                    </Stack>
                </LogOnEnter>
            </Grid>
            <Grid item xs={2} sx={{ display: 'grid' }}>
                <Stack spacing={1.5} direction='row' alignItems='center' justifyContent='end'>
                    <Typography variant='normal' sx={{ fontSize: '10px', color: `${theme.palette.subtext.main}` }}>Item Details</Typography>
                    <Box sx={{ display: 'grid', color: 'black', opacity: '0.6' }}>
                        <ChevronRightRounded/>
                    </Box>
                </Stack>
            </Grid>
        </Grid>
    );
}

export default ItemEntry;